<block-ui>
    <div class="row">
        <div class="col-sm-10">
            <form [formGroup]="searchForm">
                <div class="form-row">
                    <div class="form-group col-md-2">
                        <label for="DocEntryInput">N° Documento</label>
                        <input id="DocEntryInput" formControlName='DocEntry' class="form-control form-control-sm" (change)="GetBinnacle()">
                    </div>
                    <div class="form-group col-md-2">
                        <label>Desde</label>
                        <input type="date" formControlName="From" class="form-control form-control-sm" (change)="FromEvent()"/>
                    </div>
                    <div class="form-group col-md-2">
                        <label>Hasta</label>
                        <input type="date" formControlName="To" class="form-control form-control-sm" (change)="ToEvent()"/>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="">Estado</label>
                        <select class="form-control form-control-sm" formControlName="Event" (change)="GetBinnacle()">
                            <option class="form-control" value="" selected>Todos los estados</option>
                            <option class="form-control" value="E">Enviado</option>
                            <option class="form-control" value="I">No Enviado</option>
                        </select>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="">Tipo</label>
                        <select class="form-control form-control-sm" formControlName="Type" (change)="GetBinnacle()">
                            <option class="form-control" value="" selected>Todos los tipos</option>
                            <option class="form-control" value="OPOR">Orden de Compra</option>
                            <option class="form-control" value="OPRQ">Solicitud de Compra</option>
                        </select>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-sm-2">
            <div class="d-flex flex-row-reverse">
                <div class="form-group">
                    <button type="button"
                        class="form-control form-control-sm btn-light shadow-sm btn-st float-right"
                        (click)="GetBinnacle()">
                        <i class="fa fa-search" aria-hidden="true"></i>
                        Consultar
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="row" class="tableFixHead">
        <table class="table table-striped table-sm">
            <thead style="background-color: #172749; color: white;">
                <tr>
                    <th scope="col" style="position: sticky; top: 0;">#</th>
                    <th scope="col" style="position: sticky; top: 0;">Fecha Creación</th>
                    <th scope="col" style="position: sticky; top: 0;">Fecha Actualización</th>
                    <th scope="col" style="position: sticky; top: 0;">N° Documento</th>
                    <th scope="col" style="position: sticky; top: 0;">Estado</th>
                    <th scope="col" style="position: sticky; top: 0;">Tipo</th>
                    <th scope="col" style="position: sticky; top: 0;">Opciones</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let record of binnacle; let i = index" class="p-0">
                    <td scope="row">{{(i + 1)}}</td>
                    <td>{{record.CreateDate | date: 'dd/MM/yyyy h:mm aa' }}</td>
                    <td>{{record.LastUpdateDate | date: 'dd/MM/yyyy h:mm aa' }}</td>
                    <td>{{record.DocEntry}}</td>
                    <td>{{(record.Event == 'E')?'Enviado':((record.Event == 'N')?'No Enviado':'Intentó Enviar')}}</td>
                    <td>{{(record.Type == 'OPOR')?'Orden de Compra':'Solicitud de Compra'}}</td>
                    <td>
                        <i *ngIf="record.Event !== 'E'" class="fa fa-eye cursor-hand" aria-hidden="true" title="Detalles del error"
                            (click)="RaiseModal(content, record)"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</block-ui>

<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Datos del error</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div>
            <h6>Código: <span class="bag bag-info">{{ activeBinnacle.Code }}</span></h6>
        </div>
        <div>
            <h6>Descripción del error</h6>
            <div class="text">
                {{ activeBinnacle.Message }}
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light btn-sm shadow btn-st" (click)="CloseModal()"><i
                class="fa fa-times-circle" aria-hidden="true"></i> Cerrar&nbsp;</button>
    </div>
</ng-template>